import React, {Component} from 'react';
import {EDIT_MODE, QuestionCategory} from "../../../../../wpconfig";
import * as func from "../../../../../utils/functions";

class MPSelf extends Component {
	constructor(props) {
		super(props);

		this.state = {
			activeTab: '',
			field: 'question',
			title : '기타문의',
			checked : 'd',
			message : '확인 감사합니다.',
			status: this.props.selfStatus ? this.props.selfStatus : false,
		}
	}

	closePopup = () => {
		this.props.closePopup()
	}

	onChecked = () => {
		this.content.value = event.target.value;
		this.setState({title: event.target.value,checked : event.target.id})
		this.content.focus()
	}

	onSave = (event) => {
		event.preventDefault()

		if (this.content.value === '') {
			this.content.focus();
		} else {
			const p = {
				record_id : this.props.selfSelectId,
				self_confirm : 'N',
				'title' : this.state.title,
				'content': this.content.value,
				'category' : QuestionCategory.MY_ARTICEL,
				'kboard_option_resource_id' : this.props.selfSelectId
			}
			func.updateData('my_library/resource', p).then((response) => {
				this.setState({
					message : '수정 요청되었습니다.',
					status : true
				})
				this.props.onUpdate(this.props.arrIndex, 'N', false)
			});
		}
	};

	render() {
		// const record = this.props.record;
		return (
			<div className="modal show" id="profileModify" tabIndex="-1">
				<div className={"modal-dialog modal-dialog-centered" + (!this.state.status ? ' modal-smd' : ' modal-sm')}>
					<div className="modal-content">
						{!this.state.status &&
						<h3 className="con-title">논문정보 수정 요청</h3>
						}
						<div className="modal-body">
							{this.state.status ?
								<div className="msg-desc">{this.state.message}</div>
								:
								<div className="mt-4 border-top border-lightgray font-size-14 color-lightblack">
									<div className="mt-px-10">
										<div className="custom-control custom-checkbox d-inline-block mr-2">
											<input id="a"
											       checked={this.state.checked === 'a'}
											       onChange={this.onChecked}
											       type="checkbox" className="custom-control-input" value="내 논문이 아닙니다."/>
											<label className="custom-control-label" htmlFor="a">내 논문이 아닙니다.</label>
										</div>
										<div className="custom-control custom-checkbox d-inline-block mr-2">
											<input id="b"
											       checked={this.state.checked === 'b'}
											       onChange={this.onChecked}
											       type="checkbox" className="custom-control-input" value="저자 정보가 틀렸습니다."/>
											<label className="custom-control-label" htmlFor="b">저자 정보가 틀렸습니다.</label>
										</div>
										<div className="custom-control custom-checkbox d-inline-block mr-2">
											<input id="c"
											       checked={this.state.checked === 'c'}
											       onChange={this.onChecked}
											       type="checkbox" className="custom-control-input" value="학과 정보가 틀렸습니다."/>
											<label className="custom-control-label" htmlFor="c">학과 정보가 틀렸습니다.</label>
										</div>
										<div className="custom-control custom-checkbox d-inline-block mr-2">
											<input id="d"
											       checked={this.state.checked === 'd'}
											       onChange={this.onChecked}
											       type="checkbox" className="custom-control-input" value=""/>
											<label className="custom-control-label" htmlFor="d">기타</label>
										</div>
										<textarea className="form-control mt-3" defaultValue=""
										          name="content"
										          ref={(ref) => this.content = ref}
										          placeholder="문의 내용을 작성해주세요."
										/>
									</div>
								</div>
							}
						</div>
						{this.state.status ?
							<div className="modal-footer">
								<button type="button" className="btn btn-outline-gray" onClick={this.closePopup}>
									<strong>확인</strong>
								</button>
							</div>
							:
							<div className="modal-footer">
								<button type="button" className="btn btn-outline-gray" onClick={this.closePopup}>
									<strong>취소</strong>
								</button>
								<button type="button" className="btn btn-darkblue" onClick={this.onSave}><strong>저장</strong></button>
							</div>
						}
						<button type="button" className="btn-close" onClick={this.closePopup}/>
					</div>
				</div>
			</div>
		)
	}
};

export default MPSelf;
